<template>
  <v-app
    id="login-view"
    fluid
    tag="section"
  >
    <v-app-bar
      color="deep-purple"
      dark
      dense
      style="max-height: 48px"
    >
      <v-toolbar-title>
        <v-list-item-avatar>
          <v-img
            :src="
              require('@/assets/vmd.svg')"
          />
        </v-list-item-avatar>

        <strong class="mr-1 font-weight-black">ورود به پنل کاربری</strong>
        &nbsp;
        <span class="primary--text">صندوق یار</span>
      </v-toolbar-title>
    </v-app-bar>
    <v-container>
      <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="10"
          md="6"
        >
          <v-card
            class="mx-auto my-12"
          >
            <v-img
              class="white--text align-end"
              height="200px"
              :src="require('@/assets/docks.jpg')"
            >
              <v-card-title>نام کاربری و کلمه عبور خود را وارد کنید</v-card-title>
            </v-img>
            <v-form
              ref="form"
              class="mx-2"
              lazy-validation
              @submit.prevent="handleLogin"
            >
              <v-row>
                <v-col
                  cols="12"
                  class="mt-4"
                >
                  <v-text-field
                    ref="username"
                    v-model="user.username"
                    label="نام کاربری"
                    :error-messages="errorMessages"
                    :rules="[() => user.username != '' || 'نام کاربری را وارد کنید']"
                    focused
                  />
                </v-col>
                <v-col
                  cols="12"
                >
                  <v-text-field
                    v-model="user.password"
                    :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                    :rules="[() => !!user.password || 'کلمه عبور را وارد کنید']"
                    :error-messages="errorMessages"
                    :type="show1 ? 'text' : 'password'"
                    name="password"
                    label="کلمه عبور"
                    @click:append="show1 = !show1"
                  />
                </v-col>
              </v-row>
              <div class="form-group">
                <div
                  v-if="message"
                  class="alert alert-danger"
                  role="alert"
                >
                  {{ message }}
                </div>
              </div>
            </v-form>
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="blue"
                dark
                :loading="loading"
                @click="handleLogin()"
              >
                ورود
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>

  export default {
    name: 'Login',
    data () {
      return {
        user: { username: '', password: '', email: '' },
        loading: false,
        message: '',
        errorMessages: '',
        show1: false,
      }
    },
    computed: {
      loggedIn () {
        return this.$store.state.auth.status.loggedIn
      },
    },
    created () {

    },
    methods: {
      handleLogin () {
        if (!this.$refs.form.validate()) { return }
        this.loading = true
        if (this.user.username && this.user.password) {
          this.$store.dispatch('auth/login', this.user).then((to) => {
            this.$router.push(to)
          }).catch(error => {
            this.loading = false
            this.message = error.message || error.toString()
          })
        }
      },
    },
  }
</script>

<style scoped>
</style>
